/* src/app/modules_v2/booking/locations/components/sections/location-staff-section/location-staff-dialog.component.css */
.staff-form {
  padding: 10px 0;
}
.w-100 {
  width: 100%;
}
mat-form-field {
  width: 100%;
}
.factuone-button {
  background-color: #e3fd64 !important;
  color: #1a1d23 !important;
}
.factuone-button:hover:not([disabled]) {
  background-color: #e59700 !important;
}
.factuone-button[disabled] {
  background-color: #ccc !important;
  color: #666 !important;
}
.row {
  margin-bottom: 10px;
}
.form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #555;
  margin-bottom: 10px;
}
.color-picker {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(40px, 1fr));
  gap: 10px;
  margin-bottom: 10px;
}
.color-option {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  border: 3px solid transparent;
  transition: all 0.2s;
  position: relative;
}
.color-option:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.color-option.selected {
  border-color: #333;
  box-shadow: 0 0 0 2px white, 0 0 0 4px #333;
}
.color-option.custom-color {
  background:
    linear-gradient(
      135deg,
      #667eea 0%,
      #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.color-option.custom-color input[type=color] {
  width: 100%;
  height: 100%;
  border: none;
  cursor: pointer;
  opacity: 0;
}
.color-option.custom-color:hover::before {
  content: "\1f3a8";
  position: absolute;
  font-size: 20px;
}
.inline-spinner {
  display: inline-block;
  margin-right: 8px;
}
mat-dialog-actions,
.mat-mdc-dialog-actions {
  padding: 16px 24px;
  gap: 10px;
}
.alert {
  margin-bottom: 20px;
}
.alert mat-icon {
  vertical-align: middle;
  margin-right: 8px;
}
.btn-close {
  opacity: 0.5;
  cursor: pointer;
}
.btn-close:hover {
  opacity: 1;
}
@media (max-width: 768px) {
  .color-picker {
    grid-template-columns: repeat(auto-fill, minmax(35px, 1fr));
    gap: 8px;
  }
  .color-option {
    width: 35px;
    height: 35px;
  }
}
/*# sourceMappingURL=location-staff-dialog.component.css.map */
